import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import useGetData from '../custom-hooks/useGetData'
import '../assets/style/dashboard.css'


const Dashboard = () => {

    const {data:products} = useGetData('products')
    const {data:users} = useGetData('users')

    return (
        <section>
            <Container>
                <Row>
                    <Col lg='3' className=''>
                        <div className='revenue__box box'>
                            <h5>Total Sales</h5>
                            <span>$7890</span>
                        </div>
                    </Col>
                    <Col lg='3' className=''>
                        <div className='order__box box'>
                            <h5>Orders</h5>
                            <span>7890</span>
                        </div>
                    </Col>
                    <Col lg='3' className=''>
                        <div className='products__box box'>
                            <h5>Total Products</h5>
                            <span>{products.length}</span>
                        </div>
                    </Col>
                    <Col lg='3' className=''>
                        <div className='user__box box'>
                            <h5>Total Users</h5>
                            <span>{users.length}</span>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Dashboard